export const curState = state => state
